module.exports = __webpack_public_path__ + "img/giphy.66841fa6.gif";